<template>
  <div class="container print-resident-account">
    <ErrorsMessages :errors="errors" />
    <b-overlay :show="loading" opacity="0.99">
      <div v-show="datas.length === 0" class="v-clean p-5">
        <h6 class="text-center upper-text worksansr">
          LANÇAMENTO NÃO ENCONTRADO!
        </h6>
      </div>
      <div v-if="datas.length > 0">
        <div class="mb-5 content-btn-print d-flex justify-content-end">
          <v-btn class="btn-print" @click="printOut">
            <i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR
          </v-btn>
        </div>

        <div class="invoice-document bg-white">
          <!-- Header da Fatura -->
          <div class="invoice-header">
            <div class="row align-items-start">
              <!-- Logo da Empresa -->
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12">
                <div class="company-logo">
                  <img
                    v-if="rest_home_logo_url"
                    class="rest_home_logo_url"
                    :src="rest_home_logo_url"
                    alt="Logo"
                  />
                  <div v-if="!rest_home_logo_url" class="company-name">
                    <strong class="text-uppercase">{{ rest_home_name }}</strong>
                  </div>
                </div>
              </div>

              <!-- Informações da Empresa -->
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <div class="company-info">
                  <h5 class="company-title">
                    {{ rest_home_fantasy_name || rest_home_name }}
                  </h5>
                  <div class="company-details">
                    <p class="mb-1">{{ getCompanyAddress() }}</p>
                    <p class="mb-1">{{ getCompanyPhone() }}</p>
                    <p class="mb-1">
                      CNPJ: {{ getCompanyCNPJ() }}
                      <span class="ml-3">IE: {{ getCompanyIE() }}</span>
                    </p>
                    <p class="mb-1">{{ getCompanyLegalName() }}</p>
                  </div>
                </div>
              </div>

              <!-- Data e Número da Fatura -->
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12">
                <div class="invoice-meta text-right">
                  <p class="invoice-date mb-1">
                    {{ moment().format("DD/MM/YYYY") }}
                  </p>
                  <p class="invoice-type mb-0">Venda {{ getSaleNumber() }}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Separador -->
          <hr class="header-divider" />

          <!-- Informações do Cliente/Residente -->
          <div class="client-info" v-if="resident">
            <div class="row">
              <div class="col-12">
                <h6 class="client-name">{{ resident.name }}</h6>
                <div class="client-details">
                  <p class="mb-1">
                    <span v-if="resident.cpf">CPF: {{ resident.cpf }}</span>
                    <span v-if="resident.rg" class="ml-4"
                      >RG: {{ resident.rg }}</span
                    >
                    <span v-if="!resident.cpf && !resident.rg"
                      >CPF: 000.000.000-00 RG: 00000000</span
                    >
                  </p>
                  <p class="mb-1">
                    {{ getResidentAddress(resident) }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- Separador -->
          <hr class="section-divider" />

          <!-- Tabela de Itens -->
          <div class="invoice-table">
            <table class="table table-bordered">
              <thead class="table-header">
                <tr>
                  <th class="text-center" style="width: 8%">Qt.</th>
                  <th style="width: 30%">Produto/Serviço</th>
                  <th style="width: 32%">Detalhe do item</th>
                  <th class="text-right" style="width: 15%">Valor unitário</th>
                  <th class="text-right" style="width: 15%">Subtotal</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in data" :key="index">
                  <template v-if="!item._id">
                    <!-- Quantidade -->
                    <td class="text-center">
                      {{ item.quantity || item.amount || 1 }}
                    </td>

                    <!-- Produto/Serviço -->
                    <td>
                      <div class="product-name">
                        <strong v-if="item.type == 'SERVICO'">
                          RECEITA - {{ getServiceName(item) }}
                        </strong>
                        <strong
                          v-else-if="item.type == 'PRODUTO' && item.entity"
                        >
                          {{ item.entity.medicine_product_name }}
                        </strong>
                        <strong v-else-if="item.type == 'MEDICAMENTO'">
                          MEDICAMENTOS
                        </strong>
                        <strong
                          v-else-if="item.finance_configuration_category_name"
                        >
                          {{ getCategoryName(item) }}
                        </strong>
                        <strong v-else>
                          {{ item.description || "ITEM" }}
                        </strong>
                      </div>
                    </td>

                    <!-- Detalhe do item -->
                    <td>
                      <div class="item-details">
                        <!-- Para hospedagem/serviços -->
                        <div v-if="isHospedagem(item)">
                          {{ item.description }}
                          <span v-if="item.resident_has_service_date">
                            {{
                              getServicePeriod(item.resident_has_service_date)
                            }}
                          </span>
                        </div>

                        <!-- Para medicamentos - lista os nomes -->
                        <div v-else-if="item.type == 'MEDICAMENTO'">
                          <span
                            v-if="
                              item.entity && item.entity.medicine_product_name
                            "
                          >
                            {{
                              getMedicineName(item.entity.medicine_product_name)
                            }}
                          </span>
                          <span v-else-if="item.description">
                            {{ getMedicineName(item.description) }}
                          </span>
                          <span v-else> MEDICAMENTOS DIVERSOS </span>
                        </div>

                        <!-- Para produtos -->
                        <div v-else-if="item.type == 'PRODUTO' && item.entity">
                          <div>
                            <small
                              ><strong>Lote:</strong>
                              {{ item.entity.lot || "N/A" }}</small
                            ><br />
                            <small
                              ><strong>Validade:</strong>
                              {{ item.entity.due_date || "N/A" }}</small
                            >
                          </div>
                        </div>

                        <!-- Para outros itens - descrição simples -->
                        <div v-else>
                          {{ item.description || "--" }}
                        </div>
                      </div>
                    </td>

                    <!-- Valor unitário -->
                    <td class="text-right">
                      {{ formatMoney(String(item.value || 0)) }}
                    </td>

                    <!-- Subtotal -->
                    <td class="text-right">
                      <strong>{{
                        formatMoney(
                          String(
                            (item.value || 0) *
                              (item.quantity || item.amount || 1)
                          )
                        )
                      }}</strong>
                    </td>
                  </template>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Totais -->
          <div class="invoice-totals">
            <div class="row">
              <div class="col-xl-8 col-lg-8 col-md-6"></div>
              <div class="col-xl-4 col-lg-4 col-md-6">
                <table class="totals-table">
                  <tr>
                    <td class="text-right"><strong>Total</strong></td>
                    <td class="text-right total-value">
                      <strong>{{ formatMoney(String(totalValue)) }}</strong>
                    </td>
                  </tr>
                  <tr class="total-final">
                    <td class="text-right"><strong>Valor líquido</strong></td>
                    <td class="text-right">
                      <strong>{{ formatMoney(String(totalValue)) }}</strong>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>

          <!-- Condições de Pagamento -->
          <div class="payment-conditions" v-if="true">
            <div class="row">
              <div class="col-12">
                <h6><strong>Condição de pagamento:</strong></h6>
                <p><strong>Forma de pagamento:</strong> Boleto Bancário</p>

                <table class="payment-table table table-bordered mt-3">
                  <thead>
                    <tr>
                      <th>Nº</th>
                      <th>Vencimento</th>
                      <th class="text-right">Valor (R$)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1º</td>
                      <td>{{ getPaymentDate() }}</td>
                      <td class="text-right">
                        {{ formatMoney(String(totalValue)) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-5 content-btn-print d-flex justify-content-end">
          <v-btn class="btn-print" @click="printOut">
            <i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR
          </v-btn>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages";

import api from "../../../services/api";

import routes from "../../../routes";

import { userData } from "../../../lib/functions";

import { getAge } from "../../../lib/getAgeByDate";

import {
  formatDate,
  formatMoney,
  professionalClassCouncilValue,
} from "../../../lib/format";

import moment from "moment";

export default {
  name: "ResidentAccountPrints",

  components: {
    ErrorsMessages,
  },

  data() {
    return {
      loading: false,

      resident_id: "",
      ids: [],
      types: [],
      type: "",
      origin: "",
      movement: "",

      errors: [],

      data: [],
      datas: [],
      resident: null,

      options: {
        page: 1,
      },

      totalValue: 0,

      user: {},
      rest_home_name: "",
      rest_home_fantasy_name: "",
      rest_home_logo_url: null,
      logo: null,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    moment,
    getAge,
    formatDate,
    formatMoney,
    professionalClassCouncilValue,

    // Métodos helper para o template
    getServiceName(item) {
      return item.service_name || "HOSPEDAGEM";
    },

    getCategoryName(item) {
      return item.finance_configuration_category_name
        ? item.finance_configuration_category_name.toUpperCase()
        : "ITEM";
    },

    isHospedagem(item) {
      return item.description && item.description.indexOf("HOSPEDAGEM") !== -1;
    },

    getServicePeriod(date) {
      return (
        moment(date).format("DD/MM") +
        " até " +
        moment(date).add(1, "month").format("DD/MM")
      );
    },

    getDefaultServicePeriod() {
      return (
        moment().format("DD/MM") +
        " até " +
        moment().add(1, "month").format("DD/MM")
      );
    },

    getMedicineName(name) {
      return name ? name.toUpperCase() : "MEDICAMENTO";
    },

    getResidentAddress(resident) {
      let address = resident.address || "--";
      if (resident.city) {
        address += " - " + resident.city;
      }
      if (resident.uf_initials) {
        address += " - " + resident.uf_initials;
      }
      if (resident.cep) {
        address += " - CEP: " + resident.cep;
      }
      return address;
    },

    getCompanyAddress() {
      return (
        this.user.rest_home_address ||
        "Rua Exemplo, 123 - Bairro - Cidade - Estado - CEP: 00000-000"
      );
    },

    getCompanyPhone() {
      return this.user.rest_home_first_phone || "--";
    },

    getCompanyCNPJ() {
      return this.user.rest_home_cnpj || "--";
    },

    getCompanyIE() {
      return this.user.rest_home_ie || "--";
    },

    getCompanyLegalName() {
      return this.user.rest_home_fantasy_name;
    },

    getSaleNumber() {
      if (this.resident && this.resident.id) {
        return this.resident.id;
      }
      return "--";
    },

    getPaymentDate() {
      if (this.data.length > 0 && this.data[0].due_date) {
        return moment(this.data[0].due_date).format("DD/MM/YYYY");
      }
      return moment().format("DD/MM/YYYY");
    },

    getSignature() {
      return professionalClassCouncilValue({
        id: this.user.professional_class_council_id,
        name: this.user.name,
        profile: this.user.profile_name,
        cpf: this.user.cpf,
        office: this.user.office,
        value: this.user.professional_class_council_value,
      });
    },

    getCurrentDateTime() {
      return moment().format("DD/MM/YYYY HH:mm:ss");
    },

    retrieve() {
      const { resident_id, types, origin, movement, ids } =
        routes.history.current.params;

      if (!resident_id || !types || !ids) {
        this.errors = ["Lançamento não encontrado"];
        return;
      }

      this.resident_id = resident_id;
      this.types = types.split(",");
      this.origin = origin;
      this.movement = movement;
      this.ids = ids.split(",");

      const { user, logo } = userData();

      this.user = user;
      this.rest_home_name = user.rest_home_name;
      this.rest_home_fantasy_name = user.rest_home_fantasy_name;
      this.rest_home_logo_url = user.logo_url;
      this.logo = logo;

      this.get();
    },

    async get() {
      try {
        this.loading = true;

        const { resident_id, types, origin, movement, ids } = this;

        let params = { resident_id, types, origin, movement, ids };

        const response = await api.get("/rest-home/resident/account/prints", {
          params,
        });

        const { data, resident, error, errors } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          let d = [];
          let totalValue = 0;
          for (let item of data) {
            for (let i of item.data) {
              if (i.total) {
                totalValue = parseFloat(totalValue) + parseFloat(i.total);
              }
              d.push(i);
            }
          }
          this.datas = data;
          this.data = d;
          this.resident = resident;
          this.totalValue = totalValue;
          this.errors = [];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    printOut() {
      window.print();
    },
  },
};
</script>

<style scoped>
/* Estilos gerais para impressão */
.print-resident-account {
  font-family: "WorkSans-Regular", Arial, sans-serif;
  color: #333;
  background-color: #fff;
}

.invoice-document {
  max-width: 100%;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ddd;
  background-color: #fff;
  min-height: 100vh;
}

/* Header da fatura */
.invoice-header {
  margin-bottom: 20px;
}

.company-logo {
  display: flex;
  align-items: center;
  height: 80px;
}

.rest_home_logo_url {
  max-height: 80px;
  max-width: 100%;
  object-fit: contain;
}

.company-name {
  font-size: 18px;
  font-weight: bold;
}

.company-info {
  text-align: left;
}

.company-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
}

.company-details p {
  font-size: 13px;
  margin-bottom: 3px;
  color: #333;
  line-height: 1.3;
}

.invoice-meta {
  text-align: right;
}

.invoice-date {
  font-size: 14px;
  color: #666;
}

.invoice-type {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

/* Separadores */
.header-divider {
  border: none;
  border-top: 2px solid #333;
  margin: 20px 0;
}

.section-divider {
  border: none;
  border-top: 1px solid #ddd;
  margin: 15px 0;
}

/* Informações do cliente */
.client-info {
  margin-bottom: 20px;
  padding: 15px;
  border: 2px solid #000;
  background-color: #fff;
}

.client-name {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
}

.client-details p {
  font-size: 13px;
  margin-bottom: 4px;
  color: #333;
  line-height: 1.4;
}

.client-dates {
  font-size: 13px;
  color: #666;
  margin-top: 8px;
}

/* Tabela de itens */
.invoice-table {
  margin-bottom: 20px;
}

.table-header th {
  background-color: #f8f9fa;
  font-weight: bold;
  font-size: 14px;
  padding: 12px 8px;
  border: 1px solid #dee2e6;
  color: #333;
}

.table tbody td {
  padding: 12px 8px;
  border: 1px solid #dee2e6;
  font-size: 14px;
  vertical-align: top;
}

.product-name {
  font-weight: 500;
}

.item-details {
  color: #666;
  font-size: 13px;
}

/* Totais */
.invoice-totals {
  margin-bottom: 20px;
}

.totals-table {
  width: 100%;
  border-collapse: collapse;
}

.totals-table td {
  padding: 8px 12px;
  border: 1px solid #dee2e6;
  font-size: 14px;
}

.total-final {
  background-color: #f8f9fa;
}

.total-value {
  font-size: 16px;
}

/* Condições de pagamento */
.payment-conditions {
  margin-bottom: 30px;
}

.payment-conditions h6 {
  margin-bottom: 10px;
  color: #333;
}

.payment-table {
  max-width: 400px;
}

.payment-table th,
.payment-table td {
  padding: 8px 12px;
  font-size: 14px;
  border: 1px solid #dee2e6;
}

.payment-table th {
  background-color: #f8f9fa;
  font-weight: bold;
}

/* Assinatura */
.signature-section {
  margin: 40px 0 20px 0;
  padding-top: 20px;
  border-top: 1px solid #ddd;
}

.signature-section p {
  font-size: 14px;
  color: #666;
}

/* Rodapé da página */
.page-footer {
  text-align: right;
  margin-top: 20px;
  padding-top: 10px;
  border-top: 1px solid #eee;
}

/* Estilos para impressão */
@media print {
  .print-resident-account .content-btn-print {
    display: none !important;
  }

  .invoice-document {
    border: none;
    padding: 15px;
    box-shadow: none;
    max-width: none;
    margin: 0;
  }

  .invoice-header,
  .client-info,
  .invoice-table,
  .invoice-totals,
  .payment-conditions,
  .signature-section {
    page-break-inside: avoid;
  }

  .table {
    border-collapse: collapse;
    width: 100%;
  }

  .table th,
  .table td {
    border: 1px solid #000 !important;
    font-size: 12px !important;
    padding: 6px 8px !important;
  }

  .table-header th {
    background-color: #f8f9fa !important;
    -webkit-print-color-adjust: exact;
  }

  .company-title {
    font-size: 16px !important;
  }

  .invoice-type {
    font-size: 16px !important;
    font-weight: bold !important;
  }

  .client-name {
    font-size: 14px !important;
    font-weight: bold !important;
  }

  .totals-table td {
    border: 1px solid #000 !important;
    font-size: 12px !important;
  }

  .payment-table th,
  .payment-table td {
    border: 1px solid #000 !important;
    font-size: 12px !important;
  }

  body {
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
  }

  .header-divider {
    border-top: 1px solid #000 !important;
  }

  .section-divider {
    border-top: 1px solid #000 !important;
  }
}

/* Responsividade */
@media (max-width: 768px) {
  .invoice-meta {
    text-align: left;
    margin-top: 15px;
  }

  .company-info {
    text-align: left;
    margin-top: 15px;
  }

  .totals-table {
    font-size: 12px;
  }

  .payment-table {
    font-size: 12px;
  }
}
</style>